export default __webpack_public_path__ + "static/media/bgAdmin.3faefd32.jpg";